import "../App.css";
import React from "react";

const Tickets = () => {
  var [nombre, setNombre] = React.useState("");
  var [apellidos, setApellidos] = React.useState("");
  return (
    <div className="container">
      <form className="was-validated d-flex justify-content-center m-5">
        <div className="row w-50">
          <div className="col-md-12 ">
            <label for="validationCustom03" className="form-label">
              Nombre
            </label>
            <input
              id="validationCustom03"
              placeholder="Nombre"
              className="form-control w-100"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
              required
            />
            <div className="invalid-feedback">
              Proporciona un nombre válido.
            </div>
          </div>
          <div className="col-md-12">
            <label for="validationCustom03" className="form-label">
              Apellido
            </label>
            <input
              id="validationCustom03"
              placeholder="Nombre"
              className="form-control w-100"
              value={apellidos}
              onChange={(e) => setApellidos(e.target.value)}
              required
            />
            <div className="invalid-feedback">
              Proporciona un apellido válido.
            </div>
          </div>
          <div className="col-md-12">
            <label for="validationCustom03" className="form-label">
              Asunto
            </label>
            <select class="form-select" required aria-label="select example">
              <option value="">Abre este menú</option>
              <option value={"Sugerencia"}>Enviar sugerencia</option>
              <option value={"Reporte"}>Hacer un Reporte</option>
              <option value={"Ayuda"}>Solicitar Ayuda</option>
            </select>
          </div>
          <div className="col-md-12">
            <label for="validationTextarea" className="form-label">
              Descripcion
            </label>
            <textarea
              className="form-control is-invalid"
              id="validationTextarea"
              placeholder="Describenos la situación..."
              required
            ></textarea>
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button className="btn btn-primary" type="submit">
              Enviar formulario
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Tickets;
